import { Box, Divider, Link, Logo } from '@hover/blueprint';
import { heightHeader } from '@hover/tokens-brand';
import React from 'react';

import { Image, Spacer } from 'src/shared/components';
import { GridArea } from 'src/shared/constants';
import { usePartner, useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';
import { Route } from 'src/shared/route';

import { Navigation } from './Navigation';

const Header = () => {
  const t = useTranslate(TranslationNamespace.SHARED);
  const partner = usePartner();

  const onlyShowPartnerLogo = partner && !partner.isCobrand;

  return (
    <Box
      alignItems="center"
      as="header"
      display="grid"
      gridArea={GridArea.HEADER}
      gridTemplateColumns="auto 1fr auto"
      justifyContent="center"
      justifyItems="center"
      padding={500}
    >
      <Link
        aria-label={t('navigation.navigateToHome')}
        href={Route.PROPERTIES.path}
      >
        <Box flexDirection="row">
          {!onlyShowPartnerLogo && (
            <Logo data-testid="HoverLogo" height={heightHeader} />
          )}
          {partner && (
            <>
              <Box height={300}>
                {!onlyShowPartnerLogo && (
                  <Divider
                    alignSelf="center"
                    borderColor="neutral.200"
                    orientation="vertical"
                  />
                )}
              </Box>
              <Image
                alt={t('logo', { name: partner.name })}
                height={heightHeader}
                src={partner.logo}
              />
            </>
          )}
        </Box>
      </Link>
      <Spacer />
      <Navigation />
    </Box>
  );
};

export { Header };
